import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
// eslint-disable-next-line import/no-cycle
import { wrappedAnalytics } from './setConfiguration';
import { setProps } from './setProps';
import { deepMemoized } from './helpers';
var previousTrackingProps;
export function sendPage(_ref) {
  var chapter1 = _ref.chapter1,
      chapter2 = _ref.chapter2,
      chapter3 = _ref.chapter3,
      name = _ref.name,
      customObject = _ref.customObject;
  var formattedPageProps = deepMemoized({
    page_chapter1: chapter1 || 'Unknown',
    page_chapter3: chapter3,
    page_chapter2: chapter2,
    page: name
  });

  if (!previousTrackingProps || formattedPageProps !== previousTrackingProps) {
    previousTrackingProps = formattedPageProps;

    if (customObject && _Object$keys(customObject).length) {
      setProps(customObject, {
        events: ['page.display']
      });
    }

    wrappedAnalytics.sendEvent('page.display', formattedPageProps);
  }
}